import { Component, EventEmitter, Output, input } from '@angular/core';
import { getTimeAsUtcMidday } from '../../../../../core/helpers/date/date';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';

@Component({
  selector: 'pp-bulk-field-date',
  templateUrl: './bulk-field-date.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldDateComponent {
  ppCustomField = input<TCustomField>(undefined);
  ppCustomFields = input<TBulkCustomFields<number>>(undefined);
  ppFieldId = input<string>(undefined);
  ppCustomFieldsExtended = input<TBulkCustomFieldsExtended<number>>(undefined);
  ppDisabled = input<boolean>(false);

  @Output() ppCustomFieldsExtendedChange = new EventEmitter<TBulkCustomFieldsExtended>();
  @Output() ppCustomFieldsChange = new EventEmitter<TBulkCustomFields>();

  EIconPath = EIconPath;
  disabled = false;

  ngOnChanges(): void {
    this.disabled = this.ppDisabled() || this.ppCustomField()?.lockedValue;
  }

  updateDate(selectedDates: Date[], field: TCustomField): void {
    if (this.ppCustomField().lockedValue) {
      return;
    }

    if (selectedDates.length) {
      const customFields = this.ppCustomFields();
      const customFieldsExtended = this.ppCustomFieldsExtended();

      customFields[field.id] = getTimeAsUtcMidday(selectedDates[0]);
      customFieldsExtended[field.id] = {
        value: customFields[field.id],
        label: field.label,
        type: field.type,
      };

      this.ppCustomFieldsChange.emit(customFields);
      this.ppCustomFieldsExtendedChange.emit(customFieldsExtended);
    }
  }
}
